var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-inline-block" },
    [
      _c(
        "b-popover",
        {
          attrs: { show: _vm.show, target: _vm.btnId },
          on: {
            "update:show": function($event) {
              _vm.show = $event
            },
            click: function($event) {
              _vm.show = false
            }
          }
        },
        [
          _c(
            "template",
            { slot: "title" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-0",
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "ma-0",
          attrs: { flat: "", icon: "", color: "accent", id: _vm.btnId },
          on: {
            click: function($event) {
              return _vm.toggle()
            }
          }
        },
        [_c("v-icon", [_vm._v("live_help")])],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04a78fb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a78fb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpPopover.vue
// module id = null
// module chunks = 